// extracted by mini-css-extract-plugin
module.exports = {"tab":"style__tab__1726j","tabWrapper":"style__tabWrapper__Gik1K","infoBar":"style__infoBar__+wEq3","welcome":"style__welcome__YD+R1","leftSide":"style__leftSide__Vbb-a"};